import service from 'utils/request'
const urlObj = {
  params: "/sys/emapflow/definition/getRenderFlowComponentParamsInForm.do",
  comments: "/sys/emapflow/tasks/getFlowTaskComment.do", // 获取历史审批意见接口
  // comments: "../../mock/emap-flow-comment.json",
  seals: "/sys/emapflow/modules/elecseal/queryMySeals.do",
  signatrue: "/sys/emapflow/elecseal/submitElecSignMobile.do",
  signParam: "/sys/emapflow/elecseal/getMobileSignParam.do",
  defaultComment: "/sys/emapflow/modules/comment/queryComment.do",
  saveComment: "/sys/emapflow/modules/comment/ETC_GE_OPINIONS_ADD.do",
  getsealConfig: '/sys/emapflow/elecseal/getSealConfig.do',
  addJGSeal: '/sys/eetablemanage/seal/addJGSeal.do',
  deleteSeal: '/sys/eetablemanage/modules/sealManager/T_EET_SEAL_DELETE.do',
  updateJGSeal: '/sys/eetablemanage/seal/updateJGSeal.do',
  verificationCode: '/sys/eetablemanage/seal/getVerificationCode.do',
  checkVerificationCode: "/sys/eetablemanage/seal/checkVerificationCode.do",
  querySealByWid: '/sys/emapflow/elecseal/querySealByWids.do'
}


const getSeals = (params) => {
  params = params || {
    "pageNumber": 1,
    "pageSize": 10
  }
  return service({
    url: urlObj.seals,
    params: params
  })
}

const getSignParam = () => {
  return service({
    url: urlObj.signParam
  })
}

const getCustomUrl = (url, params) => {
  return service({
    url: url,
    params: params || {}
  })
}

const getCommentRecords = (params) => {
  return service({
    url: urlObj.comments,
    params: params
  })
}

const getFlowParams = (params) => {
  return service({
    url: urlObj.params,
    params: params
  })
}

const getSealConfig = (params) => {
  return service({
    url: urlObj.getsealConfig,
    params: params
  })
}

const getCommentSample = (params) => {
  params = params || {"pageFlag": 1};
  return service({
    url: urlObj.defaultComment,
    params: params
  })
}

const saveComment = (data) => {
  return service({
    url: urlObj.saveComment,
    method: 'post',
    data: data
  })
}
const saveSignatrue = (data) => {
  return service({
    url: urlObj.signatrue,
    method: 'post',
    data: data
  })
}

const addJGSeal = (data) => {
  return service({
    url: urlObj.addJGSeal,
    method: 'post',
    data: data
  })
}

const deleteJGSeal = (data) => {
  return service({
    url: urlObj.deleteSeal,
    method: 'post',
    data: data
  })
}

const updateJGSeal = (data) => {
  return service({
    url: urlObj.updateJGSeal,
    method: 'post',
    data: data
  })
}

const getVerificationCode = (params) => {
  return service({
    url: urlObj.verificationCode,
    params: params
  })
}

const checkVerificationCode = (params) => {
  return service({
    url: urlObj.checkVerificationCode,
    params: params
  })
}

const getSealByWid = (params) => {
  return service({
    url: urlObj.querySealByWid,
    params: params
  })
}

const commentApi = {
  getSeals,
  getSignParam,
  getCustomUrl,
  getCommentRecords,
  getFlowParams,
  getCommentSample,
  saveComment,
  saveSignatrue,
  getSealConfig,
  addJGSeal,
  deleteJGSeal,
  updateJGSeal,
  getVerificationCode,
  checkVerificationCode,
  getSealByWid
}

export {
  getSeals,
  getSignParam,
  getCustomUrl,
  getCommentRecords,
  getFlowParams,
  getCommentSample,
  saveComment,
  saveSignatrue,
  getSealConfig,
  addJGSeal,
  deleteJGSeal,
  updateJGSeal,
  getVerificationCode,
  checkVerificationCode,
  getSealByWid
}
export default commentApi
